@if (loaded) {
  <app-base-inline-form [header]="props.label" [fields]="buttons" [leftHeader]="true"></app-base-inline-form>
  <app-grid
    stateKey="WarpWeftPlan"
    gridCssClass="warp-weft-plan-grid"
    [columnDefs]="columnDefs"
    [rowData]="rowData$ | async"
    [multiSelectCells]="true"
    [showDelete]="false"
    [pagination]="false"
    [filter]="false"
  ></app-grid>
  <app-base-form [fields]="fields" [model]="fieldModel"></app-base-form>
}
